import { useTheme } from '@mui/material';

export const PriceGrowIcon = () => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 6.5L8 4.5L6 6.5"
                stroke={theme.palette.success.light}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 11.5V4.5"
                stroke={theme.palette.success.light}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
